import Main from './components/Main.vue';
import Welcome from './components/Welcome/Welcome.vue';
import Simulateur from './components/Simulateur/Simulateur.vue';

export default [
    // {
    //     path: '/a',
    //     name: 'default',
    //     components: {
    //         default: Main,
    //     },
    //     children: [
    //         {
    //             path: 'welcome',
    //             name: 'welcome',
    //             components: {
    //                 default: Welcome,
    //             },
    //         },
    //         {
    //             path: 'simulateur/:collectivite',
    //             name: 'simulateur-collectivite',
    //             components: {
    //                 default: Simulateur,
    //             },
    //         },
    //         {
    //             path: 'simulateur/generique',
    //             name: 'simulateur-generique',
    //             components: {
    //                 default: Simulateur,
    //             },
    //         },
    //     ],
    // },
    {
        path: '/welcome',
        name: 'welcome',
        components: {
            default: Welcome,
        },
    },
    {
        path: '/collectivite-:collectivite',
        name: 'simulateur-collectivite',
        components: {
            default: Simulateur,
        },
    },
    {
        path: '/simulateur-generique',
        name: 'simulateur-generique',
        components: {
            default: Simulateur,
        },
    },
    // Default redirection
    {
        path: '*',
        redirect: '/welcome',
    },
];



// WEBPACK FOOTER //
// ./src/routes.js